import { render } from "./FloatingWindowBase.vue?vue&type=template&id=0799e90e&scoped=true"
import script from "./FloatingWindowBase.vue?vue&type=script&lang=js"
export * from "./FloatingWindowBase.vue?vue&type=script&lang=js"

import "./FloatingWindowBase.vue?vue&type=style&index=0&id=0799e90e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0799e90e"

export default script